<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew"> New Tariff<v-icon right>mdi-plus</v-icon> </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.tarf }}</td>
                  <td class="text-xs-left">{{ row.item.tarfDesc }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item.tarf)"
                      query
                      @query="doQuery(row.item.tarf)"
                      remove
                      @remove="doPromptRemove(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove"> Are you sure that you want to delete the selected Tariff Code? ({{ deleteTariff }}) </confirm>
    </div>
    <v-dialog v-model="tariffReview" width="800px" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newTariff">mdi-plus</v-icon>
          <v-icon v-else-if="reviewTariff">mdi-pencil</v-icon>
          <v-icon v-else-if="queryTariff">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newTariff">Create New Tariff Code</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewTariff">Edit Tariff Code</v-toolbar-title>
          <v-toolbar-title v-else-if="queryTariff">Query Tariff Code</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newTariff">
                <v-text-field
                  :label="labels.tarf"
                  v-model="tariffForm.tarf"
                  :error-messages="errors.collect('tarf')"
                  data-vv-name="tarf"
                  :data-vv-as="labels.tarf"
                  v-validate="'required|param|max:4'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.tarf }}</v-subheader>
                <div class="queryValue">{{ tariffForm.tarf }}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryTariff"
                  :label="labels.tarfDesc"
                  v-model="tariffForm.tarfDesc"
                  :error-messages="errors.collect('tarfDesc')"
                  data-vv-name="tarfDesc"
                  :data-vv-as="labels.tarfDesc"
                  v-validate="'required|max:40'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ tariffForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ tariffForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-if="!newTariff">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ tariffForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ tariffForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions
          ><v-btn color="primary" dark class=" mr-2" @click.native="goPermittedTariff">Permitted Tariff<v-icon right>mdi-link</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" v-if="newTariff || reviewTariff" text @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [{ text: 'Tariff', value: 'tarf' }, { text: 'Description', value: 'tarfDesc' }, TableConst.tableActionHeader],
      tariffReview: false,
      newTariff: false,
      reviewTariff: false,
      queryTariff: false,
      labels: {
        tarf: 'Tariff',
        tarfDesc: 'Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      filters: {
        tarf: undefined,
        tarfDesc: undefined
      },
      tariffForm: {
        tarf: null,
        tarfDesc: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      sideFunction: [
        {
          text: 'Risk Factor',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'riskFactor' }
        },
        {
          text: 'Tariff Benefit',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'tarfBenList' }
        },
        {
          text: 'Tariff Factor',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'tarfFactor' }
        },
        {
          text: 'Tariff Premium',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'tarfPrem' }
        }
      ],
      totalItems: 0,
      selectedTariff: undefined,
      deleteTariff: '',
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit(true)
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.tariffList
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.items = []
            const { data } = result.data
            if (data) {
              data.map((tariff) => {
                const convertList = {
                  tarf: tariff.tarf,
                  tarfDesc: tariff.tarfDesc
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doCreate() {
      const apiURI = this.menu.createTariff
      if (apiURI) {
        this.$http
          .post(apiURI, this.tariffForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit(true)
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doReview(tarf) {
      this.loading = true
      this.reviewTariff = true
      this.queryTariff = false
      this.doFetchDataTarf(tarf)
      this.loading = false
    },
    async doQuery(tarf) {
      this.loading = true
      this.reviewTariff = false
      this.queryTariff = true
      this.doFetchDataTarf(tarf)
      this.loading = false
    },
    doFetchDataTarf(tarf) {
      this.resetValidator()
      this.resetMessages()
      if (tarf) {
        this.newTariff = false
        const apiURI = this.menu.getTariff
        if (apiURI) {
          this.$http
            .get(expandURI(apiURI, { tarf }))
            .then((result) => {
              const { data } = result.data
              if (data) {
                this.tariffForm.tarf = data.tariff.tarf
                this.tariffForm.tarfDesc = data.tariff.tarfDesc
                this.tariffForm.createdBy = data.createdBy
                this.tariffForm.createdDate = data.createdDate
                this.tariffForm.modifiedBy = data.modifiedBy
                this.tariffForm.modifiedDate = data.modifiedDate
                this.tariffReview = true
              }
            })
            .catch((err) => {
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newTariff) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doUpdate() {
      const apiURI = this.menu.updateTariff
      if (apiURI) {
        this.$http
          .put(apiURI, this.tariffForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit(true)
              this.doClose()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doClose() {
      this.resetValidator()
      this.resetMessages()
      this.tariffForm.tarf = null
      this.tariffForm.tarfDesc = null
      this.tariffReview = false
      setTimeout(() => {
        this.newTariff = false
      }, 200)
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.tariffForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.tariffForm.createdDate = new Date()
      this.tariffForm.modifiedBy = null
      this.tariffForm.modifiedDate = null
      this.newTariff = true
      this.tariffReview = true
    },
    async doPromptRemove(data) {
      if (data) {
        const apiURI = this.menu.checkDeleteTariff
        if (apiURI) {
          try {
            const expand = {
              tarf: data.tarf
            }
            await this.$http.get(expandURI(apiURI, expand))
            this.promptRemove = true
            this.selectedTariff = data
            this.deleteTariff = data.tarf
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        }
      }
    },
    doRemove() {
      this.resetMessages()
      const apiURI = this.menu.deleteTariff
      if (apiURI) {
        const expand = {
          tarf: this.selectedTariff.tarf
        }
        this.$http
          .delete(expandURI(apiURI, expand))
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.promptRemove = false
            this.doInit(true)
          })
          .catch((err) => {
            this.promptRemove = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.tarf = null
      this.filters.tarfDesc = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filter').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    goPermittedTariff() {
      this.$router.push({
        name: 'pmtTariffPerBusCls',
        params: {
          incomingBusCls: 'noBusCls',
          incomingTariff: this.tariffForm.tarf,
          incomingBusClsDesc: 'noBusClsDesc',
          incomingTariffDesc: this.tariffForm.tarfDesc
        }
      })
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.tariffParam.menu
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
